// extracted by mini-css-extract-plugin
export default {"main_wrapper":"about-our-story_main_wrapper__FcD5+"};